module.exports = __webpack_public_path__ + "img/Code-Space-Design.6323bc14.jpg";